<template>
	<Aspect type="mustInsist" span=5 name="六个必须坚持" />
</template>
<script>
import Aspect from "./Aspect";
export default {
	name: 'mustInsist',
	props:{
		active: {
			type: Number,
			default: 1
		}
	},
	components: {
		Aspect
	},
	data() {
		return {

		};
	},
	created() {
		/* //获取到localStorage里的值
		this.username = localStorage.getItem("username");
		this.userData.groupid = localStorage.getItem("groupid");
		this.userData.userid = localStorage.getItem("userid");
		this.groupid_list = JSON.parse(
			window.localStorage.getItem("groupid_list")
		); */

		//yes网站版 no镜像版
		//web:网页版 mirror:镜像版
		if(this.isWeb=='yes'){
			this.v_type="web";
		}else{
			this.v_type="mirror";
		}


	},
	mounted() {
	},
	methods:{},
	computed: {},
};
</script>
<style lang="scss" scoped>
	.page-tit{
		margin:25px 0;
		color:#3D3D3D;
		font-size: 16px;
		.page-name{
			color:#C42215;
		}
	}
	.menu-box{
		border-bottom: 6px solid #FBEFE3;
		margin-right: 45px;
		.el-menu{
			border:none;
			.el-menu-item{
				text-align: left;
				padding-left: 30px !important;
				font-size: 18px;
				height:60px;
				line-height: 60px;
				border-top: 1px dashed #FDDBBB;
				&.active,&:hover{
					color:#ffffff !important;
					background: linear-gradient(270deg, #EB6047 3%, #CD3A2B 100%);
				}
			}
			.el-menu-item.is-active{
				background: linear-gradient(270deg, #EB6047 3%, #CD3A2B 100%);
			}
		}
	}
	.page-content{
		.title{
			width: 860px;
			height: 40px;
			line-height: 40px;
			font-size: 18px;
			color:#ffffff;
			display: flex;
			align-items: center;
			padding-left: 40px;
			border-radius: 15px 1px 15px 1px;
			background: linear-gradient(90deg, #EB6047 0%, #CD3A2B 100%);
			margin-bottom: 20px;
			img{
				margin-right: 8px;
			}
		}
		.content-box /deep/{
			width: 800px;
			border-radius: 10px;
			padding:20px 40px;
			margin-bottom: 200px;
			min-height: 400px;
			box-shadow: 0px 0px 10px 0px rgba(193, 193, 193, 0.2);
			.el-tabs__header{
				font-size: 16px;
				.el-tabs__nav-wrap::after{
					height: 1px;
					background-color: #C42215;
				}
				.el-tabs__nav .el-tabs__item{
					font-size: 16px !important;
					&.active,&:hover{
						color:#C42215 !important;
					}
				}
				.el-tabs__nav .el-tabs__item.is-active{
					color: #C42215 !important;
				}
				.el-tabs__nav .el-tabs__active-bar{
					height: 5px !important;
					border-radius: 10px 10px 0px 0px !important;
					background: #C42215 !important;
				}
			}
			.el-tabs__content .tab-list-box li{
				font-size: 15px;
				line-height: 2;
				white-space: pre-line;
			}
		}
	}

</style>
